export default __webpack_public_path__ + "static/footfall-analytics-3364bd8833fba0f1d3becc50b0e25e99.webp";